import { ListQueryParams } from "@/models/table";
import axios from "axios";

export const getOptionsInterestingFlow = async (params: ListQueryParams, platform = false) => {
    const { page_size, page, filter_options, signal, next_page_url } = params;

    const url = next_page_url || `/interface/api/options/list/unusual_activity_flow`;
    // platform=1 opts into the enriched Options Platform schema (Type
    // column + extra filters). The legacy /options page never passes it,
    // so its grid stays byte-identical to what prod serves today.
    const defaultParams = next_page_url ? {} : { length: page_size, page, ...(platform ? { platform: 1 } : {}), ...filter_options };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
        signal,
    });

    res.data.rows = res.data.rows.map((row) => ({
        ...row,
        reason: row.reason.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    }));
    return res.data;
};

export const getOptionFlowSentiment = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, data, next_page_url, universe_id } = params;

    const url = next_page_url || `/API/v2/${universe_id}/options/list/flow_sentiment?&dgformat`;
    const defaultParams = next_page_url ? {} : { length: page_size, page, ...filter_options, ...data };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
        signal,
    });

    return res.data;
};

export type NoteResponse = { response?: string; obfuscated?: boolean };

// Now reads from /interface/api/market_intelligence/commentary/options/latest/.
// Wire shape preserved so the /options overview-tab AINote rendering
// doesn't change.
export const getOptionsNote = async (): Promise<NoteResponse> => {
    const { getCommentaryLatestAsLegacyNote } = await import("@/controllers/market-intelligence");
    return getCommentaryLatestAsLegacyNote("options");
};
